import L from "leaflet";
import * as waypoints from "@/my-leaf/routes/components/route-waypoints";
import i18n from "@/i18n";
import * as legs from "@/my-leaf/routes/components/route-legs"
import {eventBus} from "@/main";
import { GeoUtils } from "@/utils/geo-utils";

export function createContextButtons() {
    this.map.on('click', (e) => {

        if (!this.isShowMapManu || this.isDrawNoGoZonesStarted)
            return        // Проверяем, был ли клик по объекту Navarea или другому интерактивному слою
        if (e.originalEvent && e.originalEvent.target) {
            const target = e.originalEvent.target;
            console.log('Route context click target:', target, target.classList);
            // Проверяем, является ли целевой элемент маркером или полигоном Navarea
            if (target.classList && (
                target.classList.contains('leaflet-interactive') ||
                target.classList.contains('leaflet-marker-icon') ||
                target.classList.contains('leaflet-div-icon') ||
                target.closest('.leaflet-marker-icon') ||
                target.closest('.leaflet-div-icon') ||
                target.closest('.marker-cluster') ||
                target.closest('.navarea-central-tooltip') ||
                target.closest('.leaflet-popup')
            )) {
                console.log('Route context: blocking menu for interactive element');
                // Если клик был по интерактивному элементу, не показываем контекстное меню
                return;
            }
        }

        const { isGeneralRoute, isNavRoute } = this.routesStore.activeRouteTabInfo ?? {};
        const hasGeneralRoute = !!this.routesStore.generalRoute?.data;
        if (isGeneralRoute) {
            if (hasGeneralRoute) {
                return; // do not display click menu items in general route view
            }
        }

        let content
        let coordinates = GeoUtils.normalizedLatLng(e.latlng);

        const generalSelectedCheck = {};
        eventBus.$emit('has-general-route-segment-selected', generalSelectedCheck);
        if (generalSelectedCheck.hasSelected) {
            eventBus.$emit('general-route-segment-selected', null);
            return;
        }


        const addStartButtonHandler = (idStart) => {
            document.getElementById(idStart)?.addEventListener('click', (e) => {
                this.map.closePopup()
                this.isBaypassMode = true
                waypoints.addWP.call(this, coordinates, 0, {
                    portType: 0, // start,
                    port: {
                        name: `${coordinates.lat.toFixed(6)}, ${coordinates.lng.toFixed(6)}`,
                        lat: coordinates.lat,
                        lon: coordinates.lng,
                    }
                })
                legs.drawLegs.call(this);
                eventBus.$emit('draw-map-layers');
            })
        }

        const addAddButtonHandler = (idAdd) => {
            document.getElementById(idAdd)?.addEventListener('click', (e) => {
                this.map.closePopup()
                waypoints.addWP.call(this, coordinates)
                legs.drawLegs.call(this)
            })
        }

        let idStart = 'start-wp' + this.contextButtonsCount++;
        let idAdd = 'add-wp' + this.contextButtonsCount++;
        let idInsert = 'insert-wp' + this.contextButtonsCount++;
        let idMove = 'move-wp' + this.contextButtonsCount++;
        let idFinish = 'finish-wp' + this.contextButtonsCount++;
        let idFinish1 = 'finish-wp1' + this.contextButtonsCount++;
        let idFinish2 = 'finish-wp2' + this.contextButtonsCount++;

        const hasStartPoint = this.waypoints.some(wp => wp.options?.portType === 0);
        const hasFinishPoint = this.waypoints.some(wp => wp.options?.portType === 1);

        if (this.waypoints.length === 0) {
            content = `<button id="` + idStart + `" class="button-13" onclick="">` + i18n.t('map.start') + `</button>&nbsp;<button id="` + idAdd + `" class="button-13" onclick="">` + i18n.t('map.add') + `</button>`
            L.popup({autoClose: false}).setLatLng(e.latlng).setContent(content).openOn(this.map);
            
            addStartButtonHandler(idStart);
            addAddButtonHandler(idAdd);
        } else {
            content = `<button id="` + idAdd + `" class="button-13" onclick="">` + i18n.t('map.add') + `</button>&nbsp;<button id="` + idInsert + `" class="button-13" onclick="">` + i18n.t('map.insert') + `</button>`

            if (this.waypoints.length > 0 && this.isBaypassMode) {
                content = "";

                if (this.waypoints.length > 1) {
                    // finish button removed on request from Sab, show only in bypass mode with multiple points
                    content = `<button id="` + idFinish + `" class="button-13" onclick="">` + i18n.t('map.finish') + `</button>`
                }
                content += `<button id="` + idFinish1 + `" class="button-13" onclick="">` + i18n.t('map.generalRoute') + `</button>`
                content += `<button id="` + idFinish2 + `" class="button-13" onclick="">` + i18n.t('map.navRoute') + `</button>`
            }

            if (this.waypoints.length > 0 && this.selectedWaypointIndex !== undefined)
                content += `&nbsp;<button id="` + idMove + `" class="button-13" onclick="">` + i18n.t('map.move') + `</button>
                        </button>`

            L.popup({autoClose: false}).setLatLng(e.latlng).setContent(content).openOn(this.map);

            if (this.isBaypassMode) {
                document.getElementById(idFinish)?.addEventListener('click', (e) => {
                    this.map.closePopup()
                    waypoints.addWP.call(this, coordinates)
                    this.getAutoRoute('standard');
                    eventBus.$emit('switch-to-wp');                  
                })

                document.getElementById(idFinish1)?.addEventListener('click', (e) => {
                    this.map.closePopup()
                    waypoints.addWP.call(this, coordinates, hasFinishPoint ? 0 : -1)
                    this.calculateGraphRoute('preview');
                    eventBus.$emit('switch-to-general-route'); 
                    eventBus.$emit('draw-map-layers');                       
                })

                document.getElementById(idFinish2)?.addEventListener('click', (e) => {
                    this.map.closePopup()
                    waypoints.addWP.call(this, coordinates, hasFinishPoint ? 0 : -1)
                    this.getAutoRoute('graph');
                    eventBus.$emit('switch-to-wp');  
                    eventBus.$emit('draw-map-layers');                  
                })
            } else {
                document.getElementById(idAdd).addEventListener('click', (e) => {
                    this.map.closePopup()
                    waypoints.addWP.call(this, coordinates)
                    legs.drawLegs.call(this)
                })
                document.getElementById(idInsert).addEventListener('click', (e) => {
                    this.map.closePopup()
                    legs.clearLegs.call(this)
                    waypoints.insertWP.call(this, coordinates)
                    legs.drawLegs.call(this)
                });

                if (this.waypoints.length > 0 && this.selectedWaypointIndex !== undefined) {
                    document.getElementById(idMove)?.addEventListener('click', (e) => {
                        this.map.closePopup()
                        this.changeWaypointCoordinates(this.selectedWaypointIndex, coordinates)
                    });
                }
            }
        }
    })
}
